import { useState } from "react";

// Turn an axios error into { fields: {name: msg}, message: string|null }.
// FastAPI/Pydantic 422s come back as detail: [{loc:["body","amount"], msg:"…"}].
// Business errors (400) come back as detail: "some message".
export function parseApiError(error) {
  const detail = error?.response?.data?.detail;
  if (Array.isArray(detail)) {
    const fields = {};
    for (const e of detail) {
      const loc = e?.loc || [];
      const name = [...loc].reverse().find((x) => typeof x === "string" && x !== "body");
      if (name && !fields[name]) fields[name] = e?.msg || "Invalid value";
    }
    const hasFields = Object.keys(fields).length > 0;
    return { fields, message: hasFields ? null : "Please check the form and try again." };
  }
  if (typeof detail === "string") return { fields: {}, message: detail };
  return { fields: {}, message: "Something went wrong." };
}

// Field-error state for a form. Highlight fields inline; toast anything else.
export function useFormErrors() {
  const [errors, setErrors] = useState({});
  return {
    errors,
    fieldError: (name) => errors[name],
    // Call in a mutation's onError. Returns the parsed result.
    handleError: (error, toastFn) => {
      const parsed = parseApiError(error);
      setErrors(parsed.fields);
      if (parsed.message && toastFn) toastFn(parsed.message);
      return parsed;
    },
    clearField: (name) =>
      setErrors((prev) => {
        if (!prev[name]) return prev;
        const next = { ...prev };
        delete next[name];
        return next;
      }),
    clear: () => setErrors({}),
  };
}
